import { aboutContentEn, aboutContentEs } from '@/data/aboutContent';

export const translations = {
  en: {
    nav: {
      programs: 'Programs',
      tuition: 'Tuition & Financing',
      schedule: 'Schedule',
      faq: 'FAQ',
      about: 'Why Us',
      apply: 'Apply Now',
      langLabel: 'EN'
    },
    hero: {
      eyebrow: 'North Carolina · Approved Dental Assistant Academy',
      title1: 'Become a Dental Assistant I in',
      title2: 'Just 12 Weeks',
      subtitle: 'Hands-On Training • Job Placement Support • Flexible Schedules • In-House Payment Plans • Graduate Debt-Free • Bilingual Programs',
      ctaPrimary: 'Apply Now',
      ctaSecondary: 'Schedule a Call',
      stats: {
        graduatesNum: '500+',
        graduatesLabel: 'Graduates',
        weeksNum: '12',
        weeksLabel: 'Weeks',
        placementLabel: 'Flexible Payment Plans',
        langLabel: 'Bilingual'
      },
      badges: {
        handsOn: 'Hands-on',
        finishFast: 'Finish Fast',
        affordable: 'Affordable',
        bilingual: 'Bilingual'
      }
    },
    graduates: {
      kicker: 'Our Pride',
      title: 'Meet Our Graduates',
      subtitle: 'Join hundreds of students who have transformed their lives and started rewarding careers in the dental field.',
      classOf: 'Class of'
    },
    why: {
      kicker: 'Why Royal Dental Assistant Academy',
      title: 'Built for fast, real-world results',
      subtitle: 'We combine clinical-grade equipment, small class sizes, and bilingual instruction so you graduate ready for the operatory — not just the textbook.',
      features: [
        { title: 'Hands-on Clinical Training', desc: 'Practice on real dental units with chairside instruments from day one.' },
        { title: 'Certify in 12 Weeks', desc: 'Finish fast and start earning. Most students complete the program in just 12 weeks.' },
        { title: 'In-House Financing', desc: 'Affordable plans with no credit check. Pay as you learn.' },
        { title: 'Bilingual Instructors', desc: 'Classes taught in English and Spanish. Learn in the language you think in.' },
        { title: 'Two NC Campuses', desc: 'Gastonia and Lake Norman. Convenient locations, evening and weekend options.' },
        { title: 'Career Placement Support', desc: 'Resume help, mock interviews, and a network of hiring dental practices.' }
      ]
    },
    schedule: {
      kicker: 'Upcoming Classes',
      title: 'Find Your Perfect Schedule',
      subtitle: 'Choose your campus and the class format that fits your life. Seats fill quickly — secure yours below.',
      campusLabel: 'Campus',
      typeLabel: 'Class Type',
      campuses: {
        gastonia: 'Gastonia Campus',
        lakeNorman: 'Lake Norman Campus'
      },
      types: {
        saturday: 'Saturday',
        nightMonWed: 'Mon & Wed Night',
        hybrid: 'Hybrid',
        spanishSaturday: 'Spanish Saturday',
        orthodontic: 'Orthodontic'
      },
      labels: {
        start: 'Starts',
        end: 'Ends',
        time: 'Time',
        seats: 'Seats',
        seatsLeft: 'seats left',
        full: 'CLASS FULL',
        almostFull: 'Almost Full',
        open: 'Enrolling',
        enroll: 'Enroll Now',
        waitlist: 'Join Waitlist',
        none: 'No classes available with this filter. Try another campus or class type.',
        weeks: '12 weeks',
        waitlistMsg: 'Enrollment for this class is managed through a waitlist. If you are interested, please email our office to be added and notified when the next session opens.',
        emailLabel: 'Email:'
      }
    },
    waitlist: {
      title: 'Join the Waitlist',
      subtitle: "This class is currently full. Drop your details below and we'll contact you the moment a seat opens — or for the next start date.",
      classLabel: 'Class',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      phone: 'Phone',
      submit: 'Add Me to the Waitlist',
      submitting: 'Sending…',
      success: "You're on the list!",
      successDesc: "We've added you to the waitlist. We'll reach out as soon as a seat opens.",
      close: 'Close',
      error: 'Something went wrong. Please try again or call us at 704-741-0908.'
    },
    lead: {
      kicker: 'Take The First Step',
      title: 'Apply to Royal Dental Assistant Academy',
      subtitle: 'Fill out the short form below and an admissions advisor will reach out within one business day.',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email Address',
      phone: 'Phone Number',
      campus: 'Campus of Interest',
      program: 'Program Type',
      selectCampus: 'Select a campus',
      selectProgram: 'Select a program',
      submit: 'Submit Application',
      submitting: 'Submitting…',
      successTitle: 'Application Submitted!',
      successDesc: "Thank you for reaching out to Royal Dental Assistant Academy! We’re excited to connect with you. A member of our team will contact you within one business day to answer any questions you may have. If you need immediate assistance, feel free to call us at (704) 741-0908. We look forward to speaking with you!",
      errorTitle: 'Submission Failed',
      error: 'We could not submit your application. Please try again or call 704-741-0908.',
      required: 'Required',
      invalidEmail: 'Please enter a valid email',
      invalidPhone: 'Please enter a valid phone number',
      consent: 'By submitting, you agree to be contacted by Royal Dental Assistant Academy about programs and financing.'
    },
    programsTabs: {
      kicker: 'Programs & Tuition',
      title: 'Find the Right Path For You',
      tabPrograms: 'Programs',
      tabTuition: 'Tuition & Financing',
      programsLabel: 'Core Programs',
      corePrograms: [
        { name: 'Dental Assistant I', duration: '12 Weeks' },
        { name: 'Orthodontic Assistant', duration: 'Specialty Program' }
      ],
      contEdLabel: 'Available Programs',
      contEdPrograms: [
        'Dental Assistant I',
        'NC Radiology',
        'Coronal Polishing',
        'Continued Education'
      ],
      inHouseLabel: '1. In House Payment Plans',
      inHouseOptions: [
        { title: 'Pay in full', amount: '$3,650', desc: 'Secure your seat instantly.' },
        { title: 'Split payment', desc: 'Half upfront, half later.' },
        { title: 'Customized payment option', desc: 'Contact us for a tailored plan.' }
      ],
      thirdPartyLabel: '2. Third Party Payment Plans',
      thirdPartyOptions: [
        'Affirm',
        'Klarna',
        'PayPal',
        'Afterpay'
      ],
      financialAssistanceLabel: '3. Financial Assistance',
      financialAssistanceOptions: [
        { 
          title: 'WIOA', 
          desc: 'Workforce Innovation and Opportunity Act',
          extra: 'Interested in WIOA funding? Contact your local NCWorks Career Center to determine your eligibility and begin the application process.',
          btnText: 'Find Your Local NCWorks Office',
          btnLink: 'https://www.ncworks.gov/vosnet/default.aspx'
        },
        { 
          title: 'Vocational Rehab', 
          desc: 'Assistance for qualifying individuals',
          extra: 'Educational funding and support may be available for qualifying individuals. Contact your local North Carolina Vocational Rehabilitation office to determine your eligibility.',
          btnText: 'Locate a Vocational Rehabilitation Office',
          btnLink: 'https://www.ncdhhs.gov/divisions/eipd/local-office-listing'
        }
      ],
      paymentMethodsLabel: '4. Payment Methods Accepted',
      paymentMethodsOptions: [
        { title: 'Cash', icon: 'cash' },
        { title: 'Zelle', icon: 'zelle' },
        { title: 'Cash App', icon: 'cashapp' },
        { title: 'Credit Cards', desc: '(processing fee applies)', icon: 'credit' }
      ]
    },
    pricing: {
      kicker: 'Program Cost & Financial Aid',
      title: 'Graduate Debt Free',
      subtitle: 'We offer in-house financial solutions and accept WIOA funding which can cover 100% of tuition.',
      tuition: '$3,650',
      tuitionLabel: '12 Week Dental Assistant I Course',
      fee: '$50',
      feeLabel: 'Application Fee',
      optionsTitle: 'Payment Options',
      options: [
        {
          title: 'In-House Financing',
          desc: 'Flexible payment plans available directly through the academy with no credit check required.',
          extra: 'Contact us to set up a weekly or monthly payment schedule that fits your budget. A standard deposit is all it takes to secure your seat and begin your training.'
        },
        {
          title: 'WIOA Funding',
          desc: 'We accept Workforce Innovation and Opportunity Act funding, which can cover 100% of tuition for those who qualify.',
          extra: 'WIOA provides federal funding for career training. You must apply through your local employment office. Once approved, this program can fully cover your educational expenses.'
        },
        {
          title: 'Government Assistance',
          desc: 'Approved provider for NCWorks and NCDHHS.',
          extra: 'We partner with the NC Department of Health and Human Services and NCWorks. Please visit their official portals or speak with a counselor to begin your eligibility process.'
        },
        {
          title: 'Vocational Rehabilitation',
          desc: 'Government assistance program designed to help individuals with disabilities.',
          extra: 'Vocational Rehabilitation offers personalized services like career counseling, job training, and placement to overcome employment barriers and achieve independence.'
        }
      ]
    },
    certifications: {
      kicker: 'Graduating Certifications',
      title: 'More Than Just a Diploma',
      subtitle: 'With our program, you will receive multiple certificates of completion to kickstart your career.',
      items: [
        'Chairside Dental Assisting',
        'North Carolina X-ray Certification',
        'OSHA & HIPAA',
        'Sterilization & Infection Control',
        'CPR'
      ],
      contEdKicker: 'Continued Education',
      contEdTitle: 'Advance Your Career',
      contEdItems: [
        'Teeth Whitening Technician',
        'Coronal Polishing',
        'NC Radiology',
        'SPICE',
        'Radiology Challenge Exam'
      ]
    },
    team: {
      kicker: 'Meet Our Team',
      title: 'Learn from the Best in the Field',
      subtitle: 'Our dedicated team of professionals brings years of real-world clinical experience directly to your training.',
      directorTitle: 'Academy Director',
      teachersTitle: 'Our Instructors'
    },
    aboutPage: aboutContentEn,
    location: {
      kicker: 'Visit Us',
      title: 'Our Campuses',
      subtitle: 'Conveniently located to serve the greater North Carolina area. We invite you to tour our state-of-the-art facilities.',
      gastoniaTitle: 'Gastonia Campus',
      gastoniaDesc: '2020 Remount Rd, Suite D-101, Gastonia, NC 28054',
      lakeNormanTitle: 'Lake Norman Campus',
      lakeNormanDesc: '500 S Main St, Suite 113, Mooresville, NC 28115',
      directions: 'Get Directions'
    },
    gallery: {
      kicker: 'Inside the Academy',
      title: 'Our Photo Portfolio',
      subtitle: 'Take a look at our clinical setups, hands-on training sessions, and the vibrant life at our academy.'
    },
    application: {
      kicker: 'Join the Academy',
      title: 'Official Application Form',
      subtitle: 'Complete the application below to secure your spot. A $50 application fee is required to submit your application.'
    },
    footer: {
      tagline: 'Empowering the next generation of dental professionals with hands-on training and expert guidance.',
      contact: 'Contact Us',
      office: 'Office',
      email: 'Email',
      hours: 'Hours',
      hoursValue: 'Monday-Saturday 8am-7pm\nBy appointment only',
      campuses: 'Our Campuses',
      gastonia: 'Gastonia Campus',
      lakeNorman: 'Lake Norman Campus',
      quickLinks: 'Quick Links',
      programs: 'Programs',
      schedule: 'Schedule',
      apply: 'Apply Now',
      rights: 'All rights reserved.',
      credit: 'Designed & Built with ❤️ by VELZAM',
      accreditation: {
        text1: 'Royal Dental Assistant Academy programs are approved and licensed by North Carolina Dental Board and North Carolina State Board of Community Colleges.',
        text2: 'The North Carolina State Board of Community Colleges is not an accrediting agency.'
      },
      discreetAccreditation: 'Licensed by the North Carolina State Board of Community Colleges.',
      viewAccreditation: 'View Licensure'
    },
    credibility: {
      kicker: 'State-Licensed Education',
      title: 'Trusted. Licensed. Career-Focused.',
      subtitle: 'Our programs are officially approved, ensuring you receive quality education that meets state standards and prepares you for immediate employment.',
      cards: [
        { title: 'State Licensed', desc: 'Licensed by the NC State Board of Community Colleges & NC Dental Board.' },
        { title: 'Clinical Training', desc: 'Hands-on practical experience in modern dental facilities.' },
        { title: 'Career Placement', desc: 'Dedicated assistance to help you secure a job after graduation.' }
      ],
      btn: 'Learn More About Our Licensure'
    },
    chat: {
      welcome: 'Hello! 👋 I am your virtual assistant from Royal Dental Assistant Academy. How can I help you today?',
      placeholder: 'Type your message...',
      online: 'Online',
      errorServer: 'Error connecting to the server',
      errorEmpty: 'Sorry, I received an empty response from the server.',
      errorConfig: '⚠️ Sorry, it seems my connection to the server is not configured or there is a temporary error.'
    },
    contactForm: {
      campus: 'Lake Norman Campus:',
      address1: '500 S Main St. Ste.113',
      address2: 'Mooresville, NC 28115',
      gastoniaCampus: 'Gastonia Campus:',
      gastoniaAddress1: '2020 Remount Rd, Suite D-101',
      gastoniaAddress2: 'Gastonia, NC 28054',
      title: 'Contact Us',
      firstName: 'First name',
      lastName: 'Last name',
      email: 'Email',
      phone: 'Phone',
      message: 'Leave us a message...',
      submit: 'Submit'
    },
    enrollmentProcess: {
      title: 'Enrollment Process',
      step1: 'Fill out online application.',
      step2: 'Complete Enrollment Form',
      step3: 'Secure Your Seat with $250 Deposit',
      testimonial: '"I can\'t even put into words how grateful I am for my time at Royal Dental Assistant Academy. Not only did I gain invaluable skills and knowledge, but the professors and staff truly cared about my success. The sense of community among the staff and students really enhanced my learning journey. The supportive environment fostered by the faculty truly sets this institution apart it\'s more than just school; it\'s a place that shaped me into the dental assistant I am today. Highly recommend!"',
      author: '- C'
    },
    reviews: {
      title: 'Google Reviews',
      subtitle: 'Based on excellent student feedback'
    }
  },
  es: {
    nav: {
      programs: 'Programas',
      tuition: 'Colegiatura y Financiamiento',
      schedule: 'Horarios',
      faq: 'Preguntas Frecuentes',
      about: 'Por qué Elegirnos',
      apply: 'Aplica Ya',
      langLabel: 'ES'
    },
    hero: {
      eyebrow: 'Carolina del Norte · Academia Certificada',
      title1: 'Conviértete en Asistente Dental I en',
      title2: 'Solo 12 Semanas',
      subtitle: 'Práctica Clínica • Apoyo de Colocación • Horarios Flexibles • Planes de Pago Internos • Gradúate Sin Deudas • Programas Bilingües',
      ctaPrimary: 'Aplica Ahora',
      ctaSecondary: 'Agenda una Llamada',
      stats: {
        graduatesNum: '500+',
        graduatesLabel: 'Graduados',
        weeksNum: '12',
        weeksLabel: 'Semanas',
        placementLabel: 'Planes de Pago Flexibles',
        langLabel: 'Inglés & Español'
      },
      badges: {
        handsOn: 'Práctico',
        finishFast: 'Rápido',
        affordable: 'Accesible',
        bilingual: 'Bilingüe'
      }
    },
    graduates: {
      kicker: 'Nuestro Orgullo',
      title: 'Conoce a Nuestros Graduados',
      subtitle: 'Únete a cientos de estudiantes que han transformado sus vidas y comenzado carreras gratificantes en el campo dental.',
      classOf: 'Clase del'
    },
    why: {
      kicker: 'Por qué Royal Dental Assistant Academy',
      title: 'Diseñada para resultados rápidos y reales',
      subtitle: 'Combinamos equipo clínico real, grupos pequeños e instrucción bilingüe para que te gradúes lista para el consultorio — no solo para el libro.',
      features: [
        { title: 'Entrenamiento Clínico Práctico', desc: 'Practica en unidades dentales reales con instrumentos profesionales desde el primer día.' },
        { title: 'Certifícate en 12 Semanas', desc: 'Termina rápido y empieza a generar ingresos. La mayoría de los estudiantes terminan en 12 semanas.' },
        { title: 'Financiamiento Interno', desc: 'Planes accesibles sin revisión de crédito. Paga mientras aprendes.' },
        { title: 'Instructores Bilingües', desc: 'Clases en inglés y español. Aprende en el idioma en el que piensas.' },
        { title: 'Dos Campus en NC', desc: 'Gastonia y Lake Norman. Ubicaciones convenientes, opciones de noche y fin de semana.' },
        { title: 'Apoyo de Colocación Laboral', desc: 'Ayuda con currículum, entrevistas de práctica y red de consultorios.' }
      ]
    },
    schedule: {
      kicker: 'Próximas Clases',
      title: 'Encuentra Tu Horario Perfecto',
      subtitle: 'Elige tu campus y el formato que mejor se adapte a tu vida. Los cupos se agotan rápido — asegura el tuyo abajo.',
      campusLabel: 'Campus',
      typeLabel: 'Tipo de Clase',
      campuses: {
        gastonia: 'Campus Gastonia',
        lakeNorman: 'Campus Lake Norman'
      },
      types: {
        saturday: 'Sábados',
        nightMonWed: 'Lun y Mié Noche',
        hybrid: 'Híbrida',
        spanishSaturday: 'Sábados Español',
        orthodontic: 'Ortodoncia'
      },
      labels: {
        start: 'Inicio',
        end: 'Fin',
        time: 'Horario',
        seats: 'Cupos',
        seatsLeft: 'cupos disponibles',
        full: 'CLASE LLENA',
        almostFull: 'Casi llena',
        open: 'Inscripción abierta',
        enroll: 'Inscríbete Ahora',
        waitlist: 'Lista de Espera',
        none: 'No hay clases con este filtro. Prueba otro campus o tipo de clase.',
        weeks: '12 semanas',
        waitlistMsg: 'La inscripción para esta clase se gestiona mediante lista de espera. Si estás interesada, por favor escríbenos a nuestro correo para ser añadida y recibir notificación cuando abra la próxima sesión.',
        emailLabel: 'Correo:'
      }
    },
    waitlist: {
      title: 'Únete a la Lista de Espera',
      subtitle: 'Esta clase está llena. Déjanos tus datos y te contactaremos en cuanto se abra un cupo — o para la próxima fecha de inicio.',
      classLabel: 'Clase',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      submit: 'Añadirme a la Lista',
      submitting: 'Enviando…',
      success: '¡Estás en la lista!',
      successDesc: 'Te hemos añadido a la lista de espera. Te contactaremos en cuanto se libere un cupo.',
      close: 'Cerrar',
      error: 'Algo salió mal. Inténtalo de nuevo o llámanos al 704-741-0908.'
    },
    lead: {
      kicker: 'Da El Primer Paso',
      title: 'Inscríbete en Royal Dental Assistant Academy',
      subtitle: 'Completa este breve formulario y un asesor de admisiones te contactará en un día hábil.',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      campus: 'Campus de interés',
      program: 'Tipo de Programa',
      selectCampus: 'Selecciona un campus',
      selectProgram: 'Selecciona un programa',
      submit: 'Enviar Inscripción',
      submitting: 'Enviando…',
      successTitle: '¡Solicitud Enviada!',
      successDesc: '¡Gracias por contactar a Royal Dental Assistant Academy! Estamos emocionados de conectar contigo. Un miembro de nuestro equipo te contactará dentro de un día hábil para responder cualquier pregunta que tengas. Si necesitas asistencia inmediata, no dudes en llamarnos al (704) 741-0908. ¡Esperamos hablar contigo pronto!',
      errorTitle: 'Error de Envío',
      error: 'No pudimos enviar tu inscripción. Inténtalo de nuevo o llama al 704-741-0908.',
      required: 'Requerido',
      invalidEmail: 'Por favor ingresa un correo válido',
      invalidPhone: 'Por favor ingresa un teléfono válido',
      consent: 'Al enviar, aceptas ser contactado por Royal Dental Assistant Academy sobre programas y financiamiento.'
    },
    programsTabs: {
      kicker: 'Programas y Colegiatura',
      title: 'Encuentra el Camino Ideal',
      tabPrograms: 'Programas',
      tabTuition: 'Colegiatura y Financiamiento',
      programsLabel: 'Programas Principales',
      corePrograms: [
        { name: 'Asistente Dental I', duration: '12 Semanas' },
        { name: 'Asistente de Ortodoncia', duration: 'Especialidad' }
      ],
      contEdLabel: 'Programas Disponibles',
      contEdPrograms: [
        'Asistente Dental I',
        'Radiología de NC',
        'Pulido Coronal',
        'Educación Continua'
      ],
      inHouseLabel: '1. Planes de Pago Internos',
      inHouseOptions: [
        { title: 'Pago completo', amount: '$3,650', desc: 'Asegura tu lugar de inmediato.' },
        { title: 'Pago dividido', desc: 'Opción de pago mitad y mitad.' },
        { title: 'Pago personalizado', desc: 'Contáctanos para un plan a tu medida.' }
      ],
      thirdPartyLabel: '2. Pagos de Terceros',
      thirdPartyOptions: [
        'Affirm',
        'Klarna',
        'PayPal',
        'Afterpay'
      ],
      financialAssistanceLabel: '3. Asistencia Financiera',
      financialAssistanceOptions: [
        { 
          title: 'Fondos WIOA', 
          desc: 'Puede cubrir la matrícula.',
          extra: '¿Interesado en fondos WIOA? Comuníquese con su centro local de carreras de NCWorks para determinar su elegibilidad y comenzar el proceso de solicitud.',
          btnText: 'Encuentre su oficina local de NCWorks',
          btnLink: 'https://www.ncworks.gov/vosnet/default.aspx'
        },
        { 
          title: 'Rehabilitación Vocacional', 
          desc: 'Asistencia para individuos que califican.',
          extra: 'Puede haber fondos educativos y apoyo disponibles para las personas que califiquen. Comuníquese con su oficina local de Rehabilitación Vocacional de Carolina del Norte para determinar su elegibilidad.',
          btnText: 'Ubique una oficina de Rehabilitación Vocacional',
          btnLink: 'https://www.ncdhhs.gov/divisions/eipd/local-office-listing'
        }
      ],
      paymentMethodsLabel: '4. Métodos de Pago Aceptados',
      paymentMethodsOptions: [
        { title: 'Efectivo', icon: 'cash' },
        { title: 'Zelle', icon: 'zelle' },
        { title: 'Cash App', icon: 'cashapp' },
        { title: 'Tarjetas de Crédito', desc: '(aplica tarifa de procesamiento)', icon: 'credit' }
      ]
    },
    pricing: {
      kicker: 'Costos del Programa y Ayuda',
      title: 'Gradúate Sin Deudas',
      subtitle: 'Ofrecemos soluciones financieras internas y aceptamos fondos WIOA que pueden cubrir el 100% de la matrícula.',
      tuition: '$3,650',
      tuitionLabel: 'Curso de Asistente Dental I (12 Semanas)',
      fee: '$50',
      feeLabel: 'Cuota de Solicitud',
      optionsTitle: 'Opciones de Pago',
      options: [
        {
          title: 'Financiamiento Interno',
          desc: 'Planes de pago flexibles directamente con la academia, sin revisión de crédito.',
          extra: 'Contáctanos para configurar un plan semanal o mensual que se ajuste a tu presupuesto. Solo se requiere un depósito inicial para asegurar tu lugar en la clase.'
        },
        {
          title: 'Fondos WIOA',
          desc: 'Aceptamos fondos de WIOA, que pueden cubrir hasta el 100% de la matrícula para quienes califiquen.',
          extra: 'WIOA provee fondos federales para entrenamiento laboral. Debes aplicar a través de tu oficina local de empleo. Una vez aprobado, el programa puede cubrir todos los gastos.'
        },
        {
          title: 'Asistencia Gubernamental',
          desc: 'Proveedor aprobado para programas de NCWorks y NCDHHS.',
          extra: 'Trabajamos en conjunto con el Departamento de Salud de NC y NCWorks. Visita sus portales oficiales para verificar tu elegibilidad y comenzar el proceso.'
        },
        {
          title: 'Rehabilitación Vocacional',
          desc: 'Programa gubernamental diseñado para ayudar a personas con discapacidades.',
          extra: 'Rehabilitación Vocacional ofrece servicios personalizados como consejería de carrera, capacitación laboral y colocación para superar barreras de empleo y lograr la independencia.'
        }
      ]
    },
    certifications: {
      kicker: 'Certificaciones Obtenidas',
      title: 'Más que un simple diploma',
      subtitle: 'Con nuestro programa, recibirás múltiples certificados para impulsar tu carrera desde el primer día.',
      items: [
        'Asistencia Dental de Sillón (Chairside)',
        'Certificación de Rayos X de Carolina del Norte',
        'OSHA y HIPAA',
        'Esterilización y Control de Infecciones',
        'RCP (CPR)'
      ],
      contEdKicker: 'Educación Continua',
      contEdTitle: 'Avanza en tu Carrera',
      contEdItems: [
        'Técnico en Blanqueamiento Dental',
        'Pulido Coronal',
        'Radiología de NC',
        'SPICE',
        'Examen de Desafío de Radiología'
      ]
    },
    team: {
      kicker: 'Conoce a Nuestro Equipo',
      title: 'Aprende de las Mejores en el Campo',
      subtitle: 'Nuestro dedicado equipo de profesionales aporta años de experiencia clínica en el mundo real directamente a tu formación.',
      directorTitle: 'Directora de la Academia',
      teachersTitle: 'Nuestras Profesoras'
    },
    aboutPage: aboutContentEs,
    location: {
      kicker: 'Visítanos',
      title: 'Nuestros Campus',
      subtitle: 'Ubicados convenientemente para servir al área de Carolina del Norte. Te invitamos a conocer nuestras instalaciones de primer nivel.',
      gastoniaTitle: 'Campus Gastonia',
      gastoniaDesc: '2020 Remount Rd, Suite D-101, Gastonia, NC 28054',
      lakeNormanTitle: 'Campus Lake Norman',
      lakeNormanDesc: '500 S Main St, Suite 113, Mooresville, NC 28115',
      directions: 'Cómo Llegar'
    },
    gallery: {
      kicker: 'Dentro de la Academia',
      title: 'Nuestro Portafolio de Fotos',
      subtitle: 'Da un vistazo a nuestros equipos clínicos, sesiones de práctica y la vibrante vida dentro de nuestra academia.'
    },
    application: {
      kicker: 'Únete a la Academia',
      title: 'Formulario Oficial de Inscripción',
      subtitle: 'Completa la solicitud a continuación para asegurar tu lugar. Se requiere una tarifa de inscripción de $50 para enviar tu solicitud.'
    },
    footer: {
      tagline: 'Empoderando a la próxima generación de profesionales dentales con capacitación práctica y orientación de expertos.',
      contact: 'Contáctanos',
      office: 'Oficina',
      email: 'Correo',
      hours: 'Horario',
      hoursValue: 'Lunes-Sábado 8am-7pm\nSolo con cita previa',
      campuses: 'Nuestros Campus',
      gastonia: 'Campus Gastonia',
      lakeNorman: 'Campus Lake Norman',
      quickLinks: 'Enlaces Rápidos',
      programs: 'Programas',
      schedule: 'Horarios',
      apply: 'Aplica Ahora',
      rights: 'Todos los derechos reservados.',
      credit: 'Diseñado y Construido con ❤️ por VELZAM',
      accreditation: {
        text1: 'Los programas de Royal Dental Assistant Academy están aprobados y licenciados por la Junta Dental de Carolina del Norte y la Junta Estatal de Colegios Comunitarios de Carolina del Norte.',
        text2: 'La Junta Estatal de Colegios Comunitarios de Carolina del Norte no es una agencia de acreditación.'
      },
      discreetAccreditation: 'Licenciada por la Junta Estatal de Colegios Comunitarios de Carolina del Norte.',
      viewAccreditation: 'Ver Licencias'
    },
    credibility: {
      kicker: 'Educación con Licencia Estatal',
      title: 'Confiable. Licenciada. Enfocada en tu Carrera.',
      subtitle: 'Nuestros programas están aprobados oficialmente, asegurando que recibas educación de calidad que cumple con los estándares estatales y te prepara para el empleo inmediato.',
      cards: [
        { title: 'Licencia Estatal', desc: 'Licenciada por la Junta Estatal de Colegios Comunitarios y la Junta Dental de NC.' },
        { title: 'Entrenamiento Clínico', desc: 'Experiencia práctica en instalaciones dentales modernas.' },
        { title: 'Ubicación Laboral', desc: 'Asistencia dedicada para ayudarte a conseguir empleo al graduarte.' }
      ],
      btn: 'Conoce Más Sobre Nuestras Licencias'
    },
    chat: {
      welcome: '¡Hola! 👋 Soy tu asistente virtual de Royal Dental Assistant Academy. ¿En qué te puedo ayudar hoy?',
      placeholder: 'Escribe tu mensaje...',
      online: 'En línea',
      errorServer: 'Error en la conexión con el servidor',
      errorEmpty: 'Lo siento, recibí una respuesta vacía del servidor.',
      errorConfig: '⚠️ Lo siento, parece que mi conexión con el servidor (n8n) no está configurada o hay un error temporal.'
    },
    contactForm: {
      campus: 'Campus Lake Norman:',
      address1: '500 S Main St. Ste.113',
      address2: 'Mooresville, NC 28115',
      gastoniaCampus: 'Campus Gastonia:',
      gastoniaAddress1: '2020 Remount Rd, Suite D-101',
      gastoniaAddress2: 'Gastonia, NC 28054',
      title: 'Contáctanos',
      firstName: 'Nombre',
      lastName: 'Apellido',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      message: 'Déjanos un mensaje...',
      submit: 'Enviar'
    },
    enrollmentProcess: {
      title: 'Proceso de Inscripción',
      step1: 'Llena la solicitud en línea.',
      step2: 'Completa el Formulario de Inscripción',
      step3: 'Asegura tu lugar con $250 de depósito',
      testimonial: '"No puedo ni expresar con palabras lo agradecida que estoy por mi tiempo en Royal Dental Assistant Academy. No solo adquirí habilidades y conocimientos invaluables, sino que los profesores y el personal realmente se preocuparon por mi éxito. El sentido de comunidad entre el personal y los estudiantes realmente mejoró mi viaje de aprendizaje. El ambiente de apoyo fomentado por la facultad realmente distingue a esta institución; es más que solo una escuela, es un lugar que me formó en la asistente dental que soy hoy. ¡Altamente recomendado!"',
      author: '- C'
    },
    reviews: {
      title: 'Reseñas de Google',
      subtitle: 'Basado en los excelentes comentarios de nuestros estudiantes'
    }
  }
};
